<div class="edit-profile-dialog-content d-flex flex-row" [class.inline-mode]="inlineMode" [class.is-saving]="saving">
  <saving-overlay [active]="saving" message="Saving your profile..."></saving-overlay>
  <div class="popup-column-group profile-photo-video-column" [attr.inert]="saving ? '' : null">

    <div class="photo-video-ui">

		<!-- <span class="material-symbols-outlined" (click)="deleteImage()">
			delete
			</span> -->
      <div class="photo-video-container">
        <div class="profile-video-ui-wrapper">
          @if (videoSelected) {
            <video (loadeddata)="positionVideo()" id="vidPreview"
            [src]="selectedVideoUrl" autoplay loop muted playsinline></video>
          }
        </div>
        <img id="imgPreview" [hidden]="videoSelected" class="imgPreview" height="100%" [src]="selectedPhoto">
        <img [hidden]="photoSelected || videoSelected" class="noProfilePhoto_img" width="100%" height="100%"
          src="../../../../assets/images/default-profile-picture-new.svg">
          <div class="ui-popover openToggler">
            <button id="muteBtn" [hidden]="!videoSelected" (click)="muted(!muteClassAdd)"
              class="item-video-sound-control" [ngClass]="{'mute' : muteClassAdd}">
            <img class="audio-control-icon-img mute-icon"
              src="../../../../assets/images/sound-muted-icon.png"
              srcset="../../../../assets/images/sound-muted-icon@2x.png 2x, ../../../../assets/images/sound-muted-icon@3x.png 3x">
              <img class="audio-control-icon-img sound-icon"
                src="../../../../assets/images/sound-unmuted-icon.png"
                srcset="../../../../assets/images/sound-unmuted-icon@2x.png 2x, ../../../../assets/images/sound-ummuted-icon@3x.png 3x">
              </button>
            </div>
          </div>
          <div ngbDropdown class="camera-menu dropdown">
            <button ngbDropdownToggle class="btn dropdown-toggle" type="button" id="cameraMenuDropdown">
              <img src="../../../../assets/images/profile-camera-icon.png"
                srcset="../../../../assets/images/profile-camera-icon@2x.png 2x, ../../../../assets/images/profile-camera-icon@3x.png 3x"
                class="profile-camera-icon">
            </button>
            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="cameraMenuDropdown">
              <a ngbDropdownItem (click)="recordVideo()"(keydown.enter)="recordVideo()" class="dropdown-item">Take a Video</a>
              <a ngbDropdownItem (click)="takePhotoDialog()" (keydown.enter)="takePhotoDialog()"  class="dropdown-item">Take a Photo</a>
              <div ngbDropdownItem class="dropdown-item upload-image"  tabindex="0"
			  (keydown.enter)="uploadedImageInput.click()"
			>
                Upload a Photo
                <input id="uploadedImage" type="file" #uploadedImageInput (change)="filePicked($event)" tabindex="-1" accept="image/jpeg,image/jpg,image/png">
              </div>
			  <a ngbDropdownItem (click)="deleteImage()" (keydown.enter)="deleteImage()" class="dropdown-item">Delete Photo or Video</a>
            </div>
          </div>

        </div>

        <div class="photo-video-hint">
          Upload a profile photo or record a short video introduction. Share your background, experience, and career goals.
          <p>Accepted photo formats: JPG, JPEG, PNG</p>
          <p>Note: Video recording is limited to 60 seconds</p>
        </div>
        <div style="align-items: center; display: flex;">
          <span class="unnanu-check-box-style-1">
            <input [(ngModel)]="sharePicture" type="checkbox" id="shareProfilePic" name=""
              class="form-check" (ngModelChange)="onChangeShare($event)">
            <label for="shareProfilePic"></label>
          </span>
          <label for="shareProfilePic" style="padding-left: 20px;">Share My Picture</label><span class="requiredAsterix"></span>
        </div>
      </div>
      <div class="popup-column-group form-container-column edit-profile-content" [attr.inert]="saving ? '' : null">
		<div class="modal-header" style="padding: 20px 0px;">
			<div class="modal-title" id="modal-title">Edit Profile
				<info-hint title="Edit Profile"
					text="This is what employers see and search on. Fields marked * are required before you can apply for a role. Your photo or 60-second intro video appears on every application, and your availability and work authorisation are used to match you to jobs."></info-hint>
			</div>
			@if (!inlineMode) {
				<button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
			}
		  </div>

        <div class="modal-body">
          <div class="required-legend"><span class="requiredAsterix">*</span> Required Information</div>
          <div class="unnanu-form-group-style-1">
            <label class="unnanu-input-label-style-1">First Name<span class="requiredAsterix">*</span></label>
            <input inputRestriction='lettersOnly' [ngClass]="{'error': showFirstNameError}" (blur)="validateFirstName()" maxlength="60"
              (change)="validateFirstName()" [(ngModel)]="firstName" type="text" name=""
              class="form-control unnanu-text-input-style-1" id="" placeholder="" (ngModelChange)="onChange($event)">
            <label [hidden]="!showFirstNameError" class="error">Enter first name</label>
          </div>
          <div class="unnanu-form-group-style-1">
            <label class="unnanu-input-label-style-1">Last Name<span class="requiredAsterix">*</span></label>
            <input inputRestriction="lettersOnly" [ngClass]="{'error': showLastNameError}" (blur)="validateLastName()" maxlength="60"
              (change)="validateLastName()" [(ngModel)]="lastName" type="text" name=""
              class="form-control unnanu-text-input-style-1" id="" placeholder="" (ngModelChange)="onChange($event)">
            <label [hidden]="!showLastNameError" class="error">Enter last name</label>
          </div>
          <div class="unnanu-form-group-style-2 has-sussgestions-dropdown">
            <label class="unnanu-input-label-style-1">Preferred Work Title<span
            class="requiredAsterix">*</span></label>
            <input inputRestriction="noNumbers" [ngClass]="{'error': showPositionError}" maxlength="100" [(ngModel)]="position"
              type="" name="" class="form-control unnanu-text-input-style-1" id="" value="" placeholder=""
              [ngbTypeahead]="search" [resultTemplate]="rtTitle" (selectItem)="positionSelected($event)" [resultFormatter]="formatter" (ngModelChange)="onChange($event)">
            <ng-template #rtTitle let-r="result" let-t="term">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8a8a8a" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="me-2" style="vertical-align:middle;flex:0 0 auto;"><rect width="20" height="14" x="2" y="7" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
              <ngb-highlight [result]="r.Name" [term]="t"></ngb-highlight>
            </ng-template>
            <label [hidden]="!showPositionError" class="error">Enter work title</label>
          </div>
          <div class="unnanu-form-group-style-2 has-sussgestions-dropdown">
            <label class="unnanu-input-label-style-1">Alternate Title (AI matching)</label>
            <input inputRestriction="noNumbers" maxlength="100" [(ngModel)]="optionalPosition1"
              type="" name="" class="form-control unnanu-text-input-style-1" id="" value="" placeholder=""
              [ngbTypeahead]="search1" [resultTemplate]="rtTitle1" (selectItem)="opPositionSelected1($event)" [resultFormatter]="formatter" (ngModelChange)="onChange($event)">
            <ng-template #rtTitle1 let-r="result" let-t="term">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8a8a8a" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="me-2" style="vertical-align:middle;flex:0 0 auto;"><rect width="20" height="14" x="2" y="7" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
              <ngb-highlight [result]="r.Name" [term]="t"></ngb-highlight>
            </ng-template>
          </div>
          <div class="unnanu-form-group-style-2 has-sussgestions-dropdown">
            <label class="unnanu-input-label-style-1">Other Title (AI matching)</label>
            <input inputRestriction="noNumbers" maxlength="100" [(ngModel)]="optionalPosition2"
              type="" name="" class="form-control unnanu-text-input-style-1" id="" value="" placeholder=""
              [ngbTypeahead]="search2" [resultTemplate]="rtTitle2" (selectItem)="opPositionSelected2($event)" [resultFormatter]="formatter" (ngModelChange)="onChange($event)">
            <ng-template #rtTitle2 let-r="result" let-t="term">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8a8a8a" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="me-2" style="vertical-align:middle;flex:0 0 auto;"><rect width="20" height="14" x="2" y="7" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
              <ngb-highlight [result]="r.Name" [term]="t"></ngb-highlight>
            </ng-template>
          </div>
          <div class="unnanu-form-group-style-2">
            <div class="d-flex justify-content-between">
              <label class="unnanu-input-label-style-1">Desired Pay Rate (Per Hour)<span
              class="requiredAsterix">*</span></label>
              <label class="unnanu-input-label-style-2" style="margin:0;">Annually (approx.):
                <span>${{roundSalRange(salarySlider.minValue) | number}}K</span> -
                <span>${{roundSalRange(salarySlider.maxValue) | number}}K</span></label>
              </div>
              <div class="pay-range-slider">
                <div class="row">
                  <div class="slider-drag-element col-9">
                    <ngx-slider [(value)]="salarySlider.minValue" [(highValue)]="salarySlider.maxValue"
                      [options]="salarySlider.options" (userChange)="salarySlider.onChange($event)">
                    </ngx-slider>
                  </div>
                  <div class="slider-value-selected col-3">
                    ${{salarySlider.minValue}}-${{salarySlider.maxValue}}
                  </div>
                  <div class="col-12">
                    <hr>
                    </div>
                  </div>
                </div>
              </div>
              <div class="unnanu-form-group-style-1">
                <label class="unnanu-input-label-style-1">Preferred Work Type<span
                class="requiredAsterix">*</span></label>
                <div class="availability-options d-flex justify-content-between">
                  <div>
                    <span class="unnanu-check-box-style-1">
                      <input [(ngModel)]="fullTime" type="checkbox" id="FullTimeCheck" name="" class="form-check" (ngModelChange)="onChange($event)">
                      <label for="FullTimeCheck"></label>
                    </span>
                    <label class="availability-label" for="FullTimeCheck">Full-Time</label>
                  </div>
                  <div>
                    <span class="unnanu-check-box-style-1">
                      <input [(ngModel)]="contract" type="checkbox" id="ContractCheck" name="" class="form-check"
                        checked (ngModelChange)="onChange($event)">
                      <label for="ContractCheck"></label>
                    </span>
                    <label class="availability-label" for="ContractCheck">Contract</label>
                  </div>
                  <div>
                    <span class="unnanu-check-box-style-1">
                      <input [(ngModel)]="intern" type="checkbox" id="InternCheck" name="" class="form-check"
                        checked (ngModelChange)="onChange($event)">
                      <label for="InternCheck"></label>
                    </span>
                    <label class="availability-label" for="InternCheck">Internship</label>
                  </div>
                  <div>
                    <span class="unnanu-check-box-style-1">
                      <input [(ngModel)]="Volunteer" type="checkbox" id="VolunteerCheck" name=""
                        class="form-check" (ngModelChange)="onChange($event)">
                      <label for="VolunteerCheck"></label>
                    </span>
                    <label class="availability-label" for="VolunteerCheck">Volunteer</label>
                  </div>
                </div>
                <label [hidden]="(fullTime || intern || contract || Volunteer)" class="error">Select at least one work type.</label>
              </div>
              <div class="unnanu-form-group-style-1">
                <label class="unnanu-input-label-style-1">Work Authorization<span
                class="requiredAsterix">*</span></label>
                <scroll-select placeholder="Select Your Work Authorization Status" ariaLabel="Work authorization"
                  [options]="workAuthOptions" [value]="workAuth" [invalid]="workAuthError"
                  (valueChange)="workAuth = $event; validateWorkAuth(); onChange($event)"></scroll-select>
                <label class="error" [hidden]="!workAuthError">Select Your Work Authorization</label>
              </div>
              <div class="unnanu-form-group-style-1">
                <label class="unnanu-input-label-style-1">Availability<span class="requiredAsterix">*</span></label>
                <scroll-select placeholder="Select Your Availability Status" ariaLabel="Availability"
                  [options]="availabilityOptions" [value]="Availability" [invalid]="AvailabilityError"
                  (valueChange)="Availability = $event; validateAvailability(); onChange($event)"></scroll-select>
                <label class="error" [hidden]="!AvailabilityError">Select Your Availability</label>
              </div>
              <div class="unnanu-form-group-style-1 has-sussgestions-dropdown">
                <label class="unnanu-input-label-style-1">Residency Location<span
                class="requiredAsterix">*</span></label>
                <div class="d-flex justify-content-between">
                  <div class="has-sussgestions-dropdown" style="width:314px;">
                    <city-suggestion [basicInfo]="basicInfo" [parentobj]="parentobj"
                    [showCityError]="showCityError" (cityUpdated)="onChange($event)"></city-suggestion>
                    <label [hidden]="!parentobj.showCityError" class="error">Enter your home city or town</label>
                  </div>
                  <div class="willing-to-relocate">
                    <span class="unnanu-check-box-style-1">
                      <input [(ngModel)]="willRelocate" type="checkbox" id="willingToRelocate" name=""
                        class="form-check" (ngModelChange)="onChange($event)">
                      <label for="willingToRelocate"></label>
                    </span>
                    <label for="willingToRelocate">Willing to Relocate</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer text-right" [class.inline-footer]="inlineMode">
              @if (!inlineMode) {
                <button type="button" class="cancel-changes-button large" [disabled]="saving" (click)="close()">Cancel</button>
              }
              <button type="button" class="save-changes-button large"
                [disabled]="saving || !isDirty || !firstName || !lastName || !position || (!intern && !contract && !fullTime && !Volunteer) || workAuth === '-1' || Availability === '-1' || parentobj.showCityError"
              (click)="saveData()">{{ saving ? 'Saving...' : 'Save Changes' }}</button>
            </div>
          </div>
        </div>
